import { Address } from "@covertree/agent-portal-graphql";

export function mapAddressToAddressLines(address: Address): string[] {
  if (!address) return ["", ""];
  const addressLine1 = `${address.streetAddress}, ${address.unitNumber?.trim() ?? ""}`;
  const addressLine2 = `${address.city}, ${address.state} ${address.zipCode}`;
  return [addressLine1, addressLine2];
}
